import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown, DropdownItem, IconButton} from '@albert-io/atomic';

import {getModelForResourceType} from 'resources/modelRegistry';

import ResetPasswordModal from 'client/components/ResetPasswordModal/ResetPasswordModal.react';

export default class SchoolAccountsActionsDropdown extends React.PureComponent {
  static propTypes = {
    student: PropTypes.instanceOf(getModelForResourceType('student_v2'))
  };

  constructor() {
    super();

    this.state = {
      showResetPasswordModal: false
    };
  }

  render() {
    const {student} = this.props;
    return (
      <>
        <Dropdown trigger={<IconButton icon='ellipsis-v' label='menu' />} position='bottom-end'>
          <DropdownItem
            icon={['fal', 'key']}
            onClick={() => this.setState({showResetPasswordModal: true})}
          >
            Reset password
          </DropdownItem>
        </Dropdown>
        {this.state.showResetPasswordModal && (
          <ResetPasswordModal
            handleClose={() => this.setState({showResetPasswordModal: false})}
            student={student}
          />
        )}
      </>
    );
  }
}
